<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code" :flex="false" :fixable="false">
            <ot-container>
                <ot-header>Header</ot-header>
                <ot-main>Main</ot-main>
            </ot-container>

            <ot-container>
                <ot-header>Header</ot-header>
                <ot-main>Main</ot-main>
                <ot-footer>Footer</ot-footer>
            </ot-container>

            <ot-container>
                <ot-aside width="200px">Aside</ot-aside>
                <ot-main>Main</ot-main>
            </ot-container>

            <ot-container>
                <ot-header>Header</ot-header>
                <ot-container>
                    <ot-aside width="200px">Aside</ot-aside>
                    <ot-main>Main</ot-main>
                </ot-container>
            </ot-container>

            <ot-container>
                <ot-header>Header</ot-header>
                <ot-container>
                    <ot-aside width="200px">Aside</ot-aside>
                    <ot-container>
                        <ot-main>Main</ot-main>
                        <ot-footer>Footer</ot-footer>
                    </ot-container>
                </ot-container>
            </ot-container>

            <ot-container>
                <ot-aside width="200px">Aside</ot-aside>
                <ot-container>
                    <ot-header>Header</ot-header>
                    <ot-main>Main</ot-main>
                </ot-container>
            </ot-container>

            <ot-container>
                <ot-aside width="200px">Aside</ot-aside>
                <ot-container>
                    <ot-header>Header</ot-header>
                    <ot-main>Main</ot-main>
                    <ot-footer>Footer</ot-footer>
                </ot-container>
            </ot-container>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%20%3Acode%3D%22code%22%20%3Aflex%3D%22false%22%20%3Afixable%3D%22false%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-header%3EHeader%3C%2Fot-header%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-header%3EHeader%3C%2Fot-header%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-footer%3EFooter%3C%2Fot-footer%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-aside%20width%3D%22200px%22%3EAside%3C%2Fot-aside%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-header%3EHeader%3C%2Fot-header%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-aside%20width%3D%22200px%22%3EAside%3C%2Fot-aside%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-header%3EHeader%3C%2Fot-header%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-aside%20width%3D%22200px%22%3EAside%3C%2Fot-aside%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-footer%3EFooter%3C%2Fot-footer%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-aside%20width%3D%22200px%22%3EAside%3C%2Fot-aside%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-header%3EHeader%3C%2Fot-header%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-aside%20width%3D%22200px%22%3EAside%3C%2Fot-aside%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-header%3EHeader%3C%2Fot-header%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-main%3EMain%3C%2Fot-main%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-footer%3EFooter%3C%2Fot-footer%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-container%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20lang%3D%22scss%22%20scoped%3E%0A.ot-header%2C%0A.ot-footer%20%7B%0A%20%20background-color%3A%20%23b3c0d1%3B%0A%20%20color%3A%20%23333%3B%0A%20%20text-align%3A%20center%3B%0A%20%20line-height%3A%206em%3B%0A%7D%0A%0A.ot-aside%20%7B%0A%20%20background-color%3A%20%23d3dce6%3B%0A%20%20color%3A%20%23333%3B%0A%20%20text-align%3A%20center%3B%0A%20%20line-height%3A%2020em%3B%0A%7D%0A%0A.ot-main%20%7B%0A%20%20background-color%3A%20%23e9eef3%3B%0A%20%20color%3A%20%23333%3B%0A%20%20text-align%3A%20center%3B%0A%20%20line-height%3A%2016em%3B%0A%7D%0A%0A.ot-row-group__childs%3E.ot-container%20%7B%0A%20%20margin-bottom%3A%2040px%3B%0A%7D%0A%0A.ot-container%3Anth-child(5)%20.ot-aside%2C%0A.ot-container%3Anth-child(6)%20.ot-aside%20%7B%0A%20%20line-height%3A%2026em%3B%0A%7D%0A%0A.ot-container%3Anth-child(7)%20.ot-aside%20%7B%0A%20%20line-height%3A%2032em%3B%0A%7D%0A%3C%2Fstyle%3E`),
        };
    },
};
</script>

<style lang="scss" scoped>
.ot-header,
.ot-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 6em;
}

.ot-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 20em;
}

.ot-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 16em;
}

.ot-row-group__childs>.ot-container {
  margin-bottom: 40px;
}

.ot-container:nth-child(5) .ot-aside,
.ot-container:nth-child(6) .ot-aside {
  line-height: 26em;
}

.ot-container:nth-child(7) .ot-aside {
  line-height: 32em;
}
</style>
